import type { OverviewBucket } from '@chukua/common';
import { OVERVIEW_BUCKETS } from '@chukua/common';

/** Tag colour and label for one exceptions-list bucket (gitaumoses4/chukua#18) — expired and missing are both hard exceptions, expiring_30/60 a warning of different urgency. */
export const OVERVIEW_BUCKET_LABELS: Record<OverviewBucket, { label: string; color: string }> = {
  expired: { label: 'Expired', color: 'error' },
  expiring_30: { label: 'Expiring in 30 days', color: 'warning' },
  expiring_60: { label: 'Expiring in 60 days', color: 'gold' },
  missing: { label: 'Missing', color: 'error' },
};

export const OVERVIEW_BUCKET_FILTERS = OVERVIEW_BUCKETS.map((bucket) => ({ text: OVERVIEW_BUCKET_LABELS[bucket].label, value: bucket }));
